import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export default function Customers() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", email: "", phone: "", vat: "", address: "", country: "IT" });

  const load = async () => {
    const { data } = await api.get("/customers");
    setList(data);
  };
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post("/customers", f);
      toast.success("Cliente creato");
      setOpen(false); setF({ name: "", email: "", phone: "", vat: "", address: "", country: "IT" });
      load();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  const del = async (id) => {
    if (!window.confirm("Eliminare cliente?")) return;
    try { await api.delete(`/customers/${id}`); toast.success("Eliminato"); load(); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };

  return (
    <div className="p-8" data-testid="customers-page">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="text-xs uppercase tracking-widest text-muted-foreground">Anagrafica</div>
          <h1 className="text-3xl font-display font-bold mt-1">Clienti</h1>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button data-testid="btn-new-customer">+ Nuovo cliente</Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Nuovo cliente</DialogTitle></DialogHeader>
            <form onSubmit={save} className="space-y-3">
              <div><Label>Ragione sociale</Label><Input data-testid="customer-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} required /></div>
              <div className="grid grid-cols-2 gap-3">
                <div><Label>Email</Label><Input data-testid="customer-email" type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} /></div>
                <div><Label>Telefono</Label><Input data-testid="customer-phone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} /></div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div><Label>Partita IVA</Label><Input data-testid="customer-vat" value={f.vat} onChange={(e) => setF({ ...f, vat: e.target.value })} /></div>
                <div><Label>Paese</Label><Input data-testid="customer-country" value={f.country} onChange={(e) => setF({ ...f, country: e.target.value })} /></div>
              </div>
              <div><Label>Indirizzo</Label><Input data-testid="customer-address" value={f.address} onChange={(e) => setF({ ...f, address: e.target.value })} /></div>
              <Button type="submit" data-testid="customer-save" className="w-full">Salva</Button>
            </form>
          </DialogContent>
        </Dialog>
      </div>

      <div className="border border-border bg-white">
        <table className="dense-table w-full">
          <thead>
            <tr><th>Ragione sociale</th><th>Email</th><th>Telefono</th><th>P.IVA</th><th>Paese</th><th></th></tr>
          </thead>
          <tbody>
            {list.map(c => (
              <tr key={c.id} data-testid={`row-customer-${c.id}`}>
                <td className="font-medium">{c.name}</td>
                <td>{c.email || "—"}</td>
                <td>{c.phone || "—"}</td>
                <td className="font-mono text-xs">{c.vat || "—"}</td>
                <td>{c.country || "—"}</td>
                <td><button className="text-destructive text-xs hover:underline" onClick={() => del(c.id)} data-testid={`del-customer-${c.id}`}>Elimina</button></td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan="6" className="text-center py-8 text-muted-foreground text-sm">Nessun cliente.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
